import React from "react";

const AchieverTemplate = ({ candidateData }) => {
    // Default sample data matching your Flutter structure
    const defaultData = {
        name: "RICHARD SANCHEZ",
        title: "MARKETING MANAGER",
        phone: "+91 860255764",
        email: "Richard@gmail.com",
        linkedin: "Linkedin.in/NoorAlam/",
        profile: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation. Ut enim ad minim veniam quis nostrud exercitation.",
        professional_experience: [
            {
                period: "2030 - PRESENT",
                position: "Marketing Manager & Specialist",
                company: "Borsella Studio",
                achievements: [
                    "Develop and execute comprehensive marketing strategies and campaigns that align with the company's goals and objectives.",
                    "Lead, mentor, and manage a high-performing marketing team, fostering a collaborative and tosaltable driver work environment.",
                    "Monitor brand consistency across marketing channels and materials."
                ]
            }
        ],
        education: [
            {
                period: "2028 - 2029",
                degree: "Barbatar of Business",
                school: "WARDIGRE UNIVERSITY",
                gpa: "GPA: 3.8 / 4.0"
            }
        ],
        skills: [
            "Project Management",
            "Public Relations",
            "Teamwork",
            "Time Management",
            "Leadership",
            "Effective Communication",
            "Critical Thinking"
        ],
        languages: [
            { language: "English", proficiency: "Fluent" },
            { language: "French", proficiency: "Patent" },
            { language: "German", proficiency: "Banca" },
            { language: "Spanish", proficiency: "Informatista" }
        ],
        projects: [
            {
                name: "Ecommerce",
                period: "Feb 2025 - Present",
                description: [
                    "Designed wireframes and mockups for product pages",
                    "Ensured responsive layouts across mobile and tablet devices",
                    "Improved checkout flow to reduce cart abandonment",
                    "Worked closely with the team to maintain design consistency"
                ],
                role: "Designer",
                technologies: "Android, Java",
                team_size: 3
            },
            {
                name: "E commerce MERN Stacks",
                period: "Jun 2021 - Present",
                description: [
                    "Designed wireframes and mockups for product pages",
                    "Ensured responsive layouts across devices",
                    "Improved checkout flow for better user experience",
                    "Implemented responsive design techniques for cross-browser compatibility"
                ],
                role: "Front End Developer",
                technologies: "CSS, JavaScript",
                team_size: 10
            },
            {
                name: "Social Media Platform",
                period: "Jan 2023 - Dec 2023",
                description: [
                    "Built user-friendly feed and profile pages",
                    "Integrated real-time chat and notifications",
                    "Developed secure authentication and authorization",
                    "Enhanced UI for better engagement and retention"
                ],
                role: "Full Stack Developer",
                technologies: "React, Node.js, MongoDB, Express",
                team_size: 6
            }
        ],
        certifications: [
            {
                name: "AWS",
                number: "34799",
                url: "w.rhjgh.com",
                date: "2025-07-15"
            },
            {
                name: "Salesforce",
                number: "12345",
                url: "www.sahcshj.com",
                date: "2025-08-07"
            }
        ]
    };

    // Use provided data or default data
    const resumeData = candidateData ? mapCandidateData(candidateData) : defaultData;

    return (
        <div
            className="w-[210mm] h-[297mm] mx-auto bg-white text-gray-900 overflow-hidden relative"
            style={{
                fontFamily: 'Arial, sans-serif',
                fontSize: '14px',
                lineHeight: '1.4'
            }}
        >
            {/* Header with rounded teal background */}
            <div className="bg-teal-200 rounded-2xl mx-6 mt-6 px-6 py-4 flex items-start justify-between">
                <div className="flex-1">
                    <h1 className="text-2xl text-left font-black uppercase tracking-wider text-black mb-1">
                        {resumeData.name}
                    </h1>
                    <p className="text-sm text-gray-700 font-normal">
                        {resumeData.title}
                    </p>
                </div>
                <div className="text-xs text-gray-800 leading-tight text-right space-y-0.5">
                    <p>Phone: {resumeData.phone}</p>
                    <p>Email: {resumeData.email}</p>
                    <p>Linkedin: {resumeData.linkedin}</p>
                </div>
            </div>

            {/* Divider line */}
            <div className="mx-6 mt-3 mb-3 border-t border-gray-400"></div>

            {/* Profile Section */}
            <div className="mx-6 mb-4">
                <h2 className="text-sm font-bold text-teal-600 mb-2">Profile</h2>
                <p className="text-xs leading-relaxed text-gray-900" style={{ lineHeight: '1.5' }}>
                    {resumeData.profile}
                </p>
            </div>

            {/* Main Content - Two Column Layout */}
            <div className="flex mx-6 gap-6">
                {/* Left Column - Main Content (Work Experience + Projects) */}
                <div className="flex-1" style={{ width: '65%' }}>
                    {/* Work Experience */}
                    <div className="mb-6">
                        <h2 className="text-sm font-bold text-teal-600 mb-1">Work Experience</h2>
                        <div className="border-b border-gray-400 mb-3"></div>
                        <div className="space-y-4">
                            {resumeData.professional_experience.map((exp, index) => (
                                <div key={index} className="mb-4">
                                    <div className="flex items-baseline justify-between mb-1">
                                        <h3 className="text-xs font-bold text-teal-700">
                                            {exp.company}
                                        </h3>
                                        <span className="text-xs font-bold text-black ml-3" style={{ minWidth: '100px' }}>
                                            {exp.period}
                                        </span>
                                    </div>
                                    <p className="text-xs text-black font-normal mb-2">
                                        {exp.position}
                                    </p>
                                    <ul className="space-y-1">
                                        {exp.achievements.map((achievement, i) => (
                                            <li key={i} className="text-xs leading-relaxed text-black">
                                                - {achievement}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Projects */}
                    <div>
                        <h2 className="text-sm font-bold text-teal-600 mb-1">Projects</h2>
                        <div className="border-b border-gray-400 mb-3"></div>
                        <div className="space-y-4">
                            {resumeData.projects.map((project, index) => (
                                <div key={index} className="mb-4">
                                    <div className="flex items-baseline justify-between mb-1">
                                        <h3 className="text-xs font-bold text-teal-700">
                                            {project.name}
                                        </h3>
                                        <span className="text-xs font-bold text-black ml-3" style={{ minWidth: '120px' }}>
                                            {project.period}
                                        </span>
                                    </div>
                                    <p className="text-xs text-black font-bold mb-2">
                                        Role: {project.role}
                                    </p>
                                    <ul className="space-y-1 mb-2">
                                        {project.description.map((desc, i) => (
                                            <li key={i} className="text-xs leading-relaxed text-black">
                                                - {desc}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="">
                                        
                                        <p className="text-xs text-black">
                                            <span className="font-normal">Team Size:</span> {project.team_size}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Column - Teal Sidebar */}
                <div className="bg-teal-200 rounded-2xl p-4" style={{ width: '35%' }}>
                    {/* Skills */}
                    <div className="mb-5">
                        <h3 className="text-sm font-bold text-teal-700 mb-1">Skills</h3>
                        <div className="border-b border-gray-500 mb-2"></div>
                        <ul className="space-y-1">
                            {resumeData.skills.map((skill, idx) => (
                                <li key={idx} className="text-xs text-black">
                                    - {skill}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Education */}
                    <div className="mb-5">
                        <h3 className="text-sm font-bold text-teal-700 mb-1">Education</h3>
                        <div className="border-b border-gray-500 mb-2"></div>
                        <div className="space-y-3">
                            {resumeData.education.map((edu, idx) => (
                                <div key={idx}>
                                    <p className="text-xs font-bold text-black mb-1">
                                        {edu.period}
                                    </p>
                                    <p className="text-xs font-bold text-black uppercase mb-1">
                                        {edu.school}
                                    </p>
                                    <p className="text-xs text-black mb-1">
                                        {edu.degree}
                                    </p>
                                    <p className="text-xs text-black">{edu.gpa}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Languages */}
                    <div className="mb-5">
                        <h3 className="text-sm font-bold text-teal-700 mb-1">Languages</h3>
                        <div className="border-b border-gray-500 mb-2"></div>
                        <ul className="space-y-1">
                            {resumeData.languages.map((lang, idx) => (
                                <li key={idx} className="text-xs text-black">
                                    - {lang.language} ({lang.proficiency})
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Certifications */}
                    <div>
                        <h3 className="text-sm font-bold text-teal-700 mb-1">Certifications</h3>
                        <div className="border-b border-gray-500 mb-2"></div>
                        <div className="grid grid-cols-2 gap-3">
                            {resumeData.certifications.map((cert, idx) => (
                                <div key={idx}>
                                    <p className="text-xs font-bold text-teal-700 mb-1">
                                        {cert.name}
                                    </p>
                                    <p className="text-xs text-black mb-0.5">
                                        Certification #: {cert.number}
                                    </p>
                                    <p className="text-xs text-black mb-0.5">
                                        Date: {cert.date}
                                    </p>
                                    <a
                                        href={safeUrl(cert.url)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs text-blue-600 underline break-all"
                                    >
                                        {cert.url}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper function to map candidateData to the expected format
const mapCandidateData = (candidateData) => {
    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData;

    return {
        name: name || "RICHARD SANCHEZ",
        title: employment?.[0]?.job_title?.title || "MARKETING MANAGER",
        phone: phone || "+91 860255764",
        email: email || "Richard@gmail.com",
        linkedin: basic_details?.linkedin || "Linkedin.in/NoorAlam/",
        profile: basic_details?.profile_summery || "Lorem ipsum dolor sit amet...",
        professional_experience: employment?.map(job => ({
            period: formatPeriod(job?.start_year, job?.end_year),
            position: job.job_title?.title || "",
            company: job.current_company || "",
            achievements: job.job_profile ? job.job_profile.split("\n") : []
        })) || [],
        education: education?.map(edu => ({
            period: `${edu?.course_duration_start_year} - ${edu?.course_duration_end_year}`,
            degree: edu?.education_course?.title || "",
            school: edu?.insitute_university || "",
            gpa: edu?.marks ? `GPA: ${edu.marks}` : ""
        })) || [],
        skills: it_skills?.map(skill => skill?.skill?.title).filter(Boolean) || [],
        languages: candidate_languages?.map(lang => ({
            language: lang.language,
            proficiency: getLanguageProficiency(lang)
        })) || [],
        projects: projects?.map(project => ({
            name: project.project_tag || "",
            period: formatProjectDateRange(project?.start_date, project?.end_date),
            description: project.project_description ? project.project_description.split("\n") : [],
            role: project.role || "",
            technologies: project.technologies || "",
            team_size: project.team_size || ""
        })) || [],
        certifications: certifications?.map(cert => ({
            name: cert.certification_name || "",
            number: cert.certification_number || "",
            url: cert.certification_url || "",
            date: cert.certification_date || ""
        })) || []
    };
};

/* Helper Functions */
const formatPeriod = (start, end) => {
    const s = start ? String(start).trim() : "";
    const e = end ? String(end).trim() : "";
    if (s && e) return `${s} - ${e}`;
    if (s && !e) return `${s} - PRESENT`;
    return "";
};

const formatProjectDateRange = (startDate, endDate) => {
    const s = startDate ? new Date(startDate) : null;
    const e = endDate ? new Date(endDate) : null;
    const fmt = (d) =>
        d?.toLocaleDateString("en-US", { month: "short", year: "numeric" }) || "";
    if (s && e) return `${fmt(s)} - ${fmt(e)}`;
    if (s && !e) return `${fmt(s)} - Present`;
    return "";
};

const getLanguageProficiency = (lang) => {
    const abilities = [];
    if (lang?.can_read) abilities.push("read");
    if (lang?.can_write) abilities.push("write");
    if (lang?.can_speak) abilities.push("speak");
    if (abilities.length === 3) return "Fluent";
    if (abilities.length === 2) return "Intermediate";
    if (abilities.length === 1) return "Basic";

    // Special cases for the sample data
    if (lang.language === "French") return "Patent";
    if (lang.language === "German") return "Banca";
    if (lang.language === "Spanish") return "Informatista";

    return "Basic";
};

const safeUrl = (u) => {
    if (!u) return "#";
    return /^https?:\/\//i.test(u) ? u : `https://${u}`;
};

export default AchieverTemplate;